import { default as _404SMGsWZpMEaMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/404.vue?macro=true";
import { default as agencyListY1HzfoLV0oMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/agencyList.vue?macro=true";
import { default as agencyMapJohPu2YsivMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/agencyMap.vue?macro=true";
import { default as agreementK9cMa5yyYXMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/agreement.vue?macro=true";
import { default as brand2F1hf98EKMMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/brand.vue?macro=true";
import { default as brandDetail96Yujz9gt8Meta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/brandDetail.vue?macro=true";
import { default as compositionApi1D7o71QIlBMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/compositionApi.vue?macro=true";
import { default as csrApi2pEHcLmcvHMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/csrApi.vue?macro=true";
import { default as _91no_93o6zafPj3g4Meta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/deeplink/[no].vue?macro=true";
import { default as desimoney1PbtLaXznMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/desimone.vue?macro=true";
import { default as bfsecretHty88sPzcaMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/bfsecret.vue?macro=true";
import { default as event186aeGkia3Jc9Meta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/event186.vue?macro=true";
import { default as event189WK127SObuFMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/event189.vue?macro=true";
import { default as event19261wu1gXcOuMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/event192.vue?macro=true";
import { default as event1933yBf0yh2PlMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/event193.vue?macro=true";
import { default as event194jrdFtiNIoBMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/event194.vue?macro=true";
import { default as event195UfMjK2lUFyMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/event195.vue?macro=true";
import { default as event196hxANRQtZ3jMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/event196.vue?macro=true";
import { default as event197a75jogq7nnMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/event197.vue?macro=true";
import { default as event198u4wa1C7tK3Meta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/event198.vue?macro=true";
import { default as event199yFyAT4Cmg1Meta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/event199.vue?macro=true";
import { default as event200dALlHJPtK1Meta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/event200.vue?macro=true";
import { default as event201RhM88BIuUiMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/event201.vue?macro=true";
import { default as event202JPx3zLyBoSMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/event202.vue?macro=true";
import { default as event203aUiMnhm8htMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/event203.vue?macro=true";
import { default as event204y2bDCYZHTIMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/event204.vue?macro=true";
import { default as event428gHDv7lzLjMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/event42.vue?macro=true";
import { default as membershipv4BzBuBShfMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/membership.vue?macro=true";
import { default as membership25053tQ7zuFg5PMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/membership2505.vue?macro=true";
import { default as faqd5agYnlZjfMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/faq.vue?macro=true";
import { default as giftx22Zz9FqZGMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/gift.vue?macro=true";
import { default as giftCompleteVDQYQI978cMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/giftComplete.vue?macro=true";
import { default as catalogK7Pj0A3DKyMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/goods/catalog.vue?macro=true";
import { default as searchF827L2IFmRMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/goods/search.vue?macro=true";
import { default as indexv9sULRx1UhMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/goods/view/index.vue?macro=true";
import { default as halfttobak0rAVc50Y6NMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/halfttobak.vue?macro=true";
import { default as index_oldzxd23gXvl2Meta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/index_old.vue?macro=true";
import { default as indexiU5nT72sMeMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/index.vue?macro=true";
import { default as loginpg17ulS2JSMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/login.vue?macro=true";
import { default as magazinedwwAG83SBdMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/magazine.vue?macro=true";
import { default as _91no_93N8FCtufB92Meta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/magazineView/[no].vue?macro=true";
import { default as mainRloPw2DIPlMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/main.vue?macro=true";
import { default as media38LUe7k7H5Meta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/media.vue?macro=true";
import { default as mediaViewMUmnnIQ0sMMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mediaView.vue?macro=true";
import { default as findff2xVituPWMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/member/find.vue?macro=true";
import { default as joinGateLA0bh370VFMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/member/joinGate.vue?macro=true";
import { default as linksnspyqqy4ykozMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/member/linksns.vue?macro=true";
import { default as register2lmBxyfaRJMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/member/register.vue?macro=true";
import { default as benefit2hvrUizRV0Meta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/benefit.vue?macro=true";
import { default as couponVecRybUo8WMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/coupon.vue?macro=true";
import { default as exchangeSokiEcAq2LMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/exchange.vue?macro=true";
import { default as exchangeDetailivRhQ5G6ecMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/exchangeDetail.vue?macro=true";
import { default as gma5eSMCpUpbVMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/gma.vue?macro=true";
import { default as gmaDetail5IKIR4nA9fMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/gmaDetail.vue?macro=true";
import { default as indexTvy0Wmpxq5Meta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/index.vue?macro=true";
import { default as modify3PaMcqHPZHMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/modify.vue?macro=true";
import { default as mypage_addPaydSEp6dEf2aMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/mypage_addPay.vue?macro=true";
import { default as mypage_addPayComplete6jC5EhHTamMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/mypage_addPayComplete.vue?macro=true";
import { default as mypage_addPayNextUOcpc6pgcYMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/mypage_addPayNext.vue?macro=true";
import { default as mypage_changePay6h5QxLa8QoMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/mypage_changePay.vue?macro=true";
import { default as mypage_changePayCompletegSG5HzHGDrMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/mypage_changePayComplete.vue?macro=true";
import { default as mypage_changePayNextX72kbZNoPAMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/mypage_changePayNext.vue?macro=true";
import { default as mypage_ddobakjsprCLbDl1Meta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/mypage_ddobak.vue?macro=true";
import { default as mypage_deliveryT0bpsIgCISMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/mypage_delivery.vue?macro=true";
import { default as orderlOTdYBmCe5Meta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/order.vue?macro=true";
import { default as orderDetailaC53CpUX5QMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/orderDetail.vue?macro=true";
import { default as pointat1MDDNLAaMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/point.vue?macro=true";
import { default as qna8MmJ7FmhrcMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/qna.vue?macro=true";
import { default as qnaWritewDmO1zOqM6Meta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/qnaWrite.vue?macro=true";
import { default as ttobakCouponZHoPLyHDitMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/ttobakCoupon.vue?macro=true";
import { default as ttobakDetailoqwNYwvI9DMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/ttobakDetail.vue?macro=true";
import { default as ttobakPaymentFdx8W4dkLAMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/ttobakPayment.vue?macro=true";
import { default as withdrawalUt8xQe0Ss8Meta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/withdrawal.vue?macro=true";
import { default as withdrawalInfoPFw9K3xdjVMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/withdrawalInfo.vue?macro=true";
import { default as newttobakapp87DuUa66iFMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/newttobakapp.vue?macro=true";
import { default as noticeList7er9BZwDbLMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/noticeList.vue?macro=true";
import { default as _91no_93LJ04X3ZtBWMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/noticeView/[no].vue?macro=true";
import { default as cart6g7LxTo1hPMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/order/cart.vue?macro=true";
import { default as payCompleteZ4KMHheEH0Meta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/order/payComplete.vue?macro=true";
import { default as payError5L3ye18VbaMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/order/payError.vue?macro=true";
import { default as payNextmOcpmVJusgMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/order/payNext.vue?macro=true";
import { default as setCombineShipping1qInkYtYdlMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/order/setCombineShipping.vue?macro=true";
import { default as setRoutineShippingZrb5bhpTaRMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/order/setRoutineShipping.vue?macro=true";
import { default as settleLkePtDR5ipMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/order/settle.vue?macro=true";
import { default as _230823a92tcYFDHBMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/privacy/230823.vue?macro=true";
import { default as _241231FCeG32r4fLMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/privacy/241231.vue?macro=true";
import { default as indexZvHeuzsllPMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/privacy/index.vue?macro=true";
import { default as probioticsJJ6QvcHnZ8Meta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/probiotics.vue?macro=true";
import { default as _91no_93J0jOeLEhrhMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/qr/link/[no].vue?macro=true";
import { default as reviewindexKn9f5RKypxMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/review/reviewindex.vue?macro=true";
import { default as reviewWriterjk83xmF79Meta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/review/reviewWrite.vue?macro=true";
import { default as _91type_93vIwrPmpNFKMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/service/[type].vue?macro=true";
import { default as ssrApi6oZQcqw0FsMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/ssrApi.vue?macro=true";
import { default as storeEventVBVcb0QBUNMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/storeEvent.vue?macro=true";
import { default as supporters15oe4kZOycXMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/supporters1.vue?macro=true";
import { default as testfuGmweiaONMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/test.vue?macro=true";
import { default as test2lukHoKgUueMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/test2.vue?macro=true";
import { default as welcome4phP3P5cYBMeta } from "/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/welcome.vue?macro=true";
import { default as CallbackNaverA6YI8z0hc3Meta } from "~/views/store/CallbackNaver.vue?macro=true";
import { default as CallbackKakaoYSbrXGtVbVMeta } from "~/views/store/CallbackKakao.vue?macro=true";
import { default as CallbackAppleXjzfs4eTsSMeta } from "~/views/store/CallbackApple.vue?macro=true";
import { default as CallbackWithDrawalKakaonknwxzx1ghMeta } from "~/views/store/CallbackWithDrawalKakao.vue?macro=true";
export default [
  {
    name: "404",
    path: "/404",
    meta: _404SMGsWZpMEaMeta || {},
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/404.vue").then(m => m.default || m)
  },
  {
    name: "agencyList",
    path: "/agencyList",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/agencyList.vue").then(m => m.default || m)
  },
  {
    name: "agencyMap",
    path: "/agencyMap",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/agencyMap.vue").then(m => m.default || m)
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/agreement.vue").then(m => m.default || m)
  },
  {
    name: "brand",
    path: "/brand",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/brand.vue").then(m => m.default || m)
  },
  {
    name: "brandDetail",
    path: "/brandDetail",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/brandDetail.vue").then(m => m.default || m)
  },
  {
    name: "compositionApi",
    path: "/compositionApi",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/compositionApi.vue").then(m => m.default || m)
  },
  {
    name: "csrApi",
    path: "/csrApi",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/csrApi.vue").then(m => m.default || m)
  },
  {
    name: "deeplink-no",
    path: "/deeplink/:no()",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/deeplink/[no].vue").then(m => m.default || m)
  },
  {
    name: "desimone",
    path: "/desimone",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/desimone.vue").then(m => m.default || m)
  },
  {
    name: "event-bfsecret",
    path: "/event/bfsecret",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/bfsecret.vue").then(m => m.default || m)
  },
  {
    name: "event-event186",
    path: "/event/event186",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/event186.vue").then(m => m.default || m)
  },
  {
    name: "event-event189",
    path: "/event/event189",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/event189.vue").then(m => m.default || m)
  },
  {
    name: "event-event192",
    path: "/event/event192",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/event192.vue").then(m => m.default || m)
  },
  {
    name: "event-event193",
    path: "/event/event193",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/event193.vue").then(m => m.default || m)
  },
  {
    name: "event-event194",
    path: "/event/event194",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/event194.vue").then(m => m.default || m)
  },
  {
    name: "event-event195",
    path: "/event/event195",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/event195.vue").then(m => m.default || m)
  },
  {
    name: "event-event196",
    path: "/event/event196",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/event196.vue").then(m => m.default || m)
  },
  {
    name: "event-event197",
    path: "/event/event197",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/event197.vue").then(m => m.default || m)
  },
  {
    name: "event-event198",
    path: "/event/event198",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/event198.vue").then(m => m.default || m)
  },
  {
    name: "event-event199",
    path: "/event/event199",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/event199.vue").then(m => m.default || m)
  },
  {
    name: "event-event200",
    path: "/event/event200",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/event200.vue").then(m => m.default || m)
  },
  {
    name: "event-event201",
    path: "/event/event201",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/event201.vue").then(m => m.default || m)
  },
  {
    name: "event-event202",
    path: "/event/event202",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/event202.vue").then(m => m.default || m)
  },
  {
    name: "event-event203",
    path: "/event/event203",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/event203.vue").then(m => m.default || m)
  },
  {
    name: "event-event204",
    path: "/event/event204",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/event204.vue").then(m => m.default || m)
  },
  {
    name: "event-event42",
    path: "/event/event42",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/event42.vue").then(m => m.default || m)
  },
  {
    name: "event-membership",
    path: "/event/membership",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/membership.vue").then(m => m.default || m)
  },
  {
    name: "event-membership2505",
    path: "/event/membership2505",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/event/membership2505.vue").then(m => m.default || m)
  },
  {
    name: "faq",
    path: "/faq",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/faq.vue").then(m => m.default || m)
  },
  {
    name: "gift",
    path: "/gift",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/gift.vue").then(m => m.default || m)
  },
  {
    name: "giftComplete",
    path: "/giftComplete",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/giftComplete.vue").then(m => m.default || m)
  },
  {
    name: "goods-catalog",
    path: "/goods/catalog",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/goods/catalog.vue").then(m => m.default || m)
  },
  {
    name: "goods-search",
    path: "/goods/search",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/goods/search.vue").then(m => m.default || m)
  },
  {
    name: "goods-view",
    path: "/goods/view",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/goods/view/index.vue").then(m => m.default || m)
  },
  {
    name: "halfttobak",
    path: "/halfttobak",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/halfttobak.vue").then(m => m.default || m)
  },
  {
    name: "index_old",
    path: "/index_old",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/index_old.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/login.vue").then(m => m.default || m)
  },
  {
    name: "magazine",
    path: "/magazine",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/magazine.vue").then(m => m.default || m)
  },
  {
    name: "magazineView-no",
    path: "/magazineView/:no()",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/magazineView/[no].vue").then(m => m.default || m)
  },
  {
    name: "main",
    path: "/main",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/main.vue").then(m => m.default || m)
  },
  {
    name: "media",
    path: "/media",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/media.vue").then(m => m.default || m)
  },
  {
    name: "mediaView",
    path: "/mediaView",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mediaView.vue").then(m => m.default || m)
  },
  {
    name: "member-find",
    path: "/member/find",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/member/find.vue").then(m => m.default || m)
  },
  {
    name: "member-joinGate",
    path: "/member/joinGate",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/member/joinGate.vue").then(m => m.default || m)
  },
  {
    name: "member-linksns",
    path: "/member/linksns",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/member/linksns.vue").then(m => m.default || m)
  },
  {
    name: "member-register",
    path: "/member/register",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/member/register.vue").then(m => m.default || m)
  },
  {
    name: "mypage-benefit",
    path: "/mypage/benefit",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/benefit.vue").then(m => m.default || m)
  },
  {
    name: "mypage-coupon",
    path: "/mypage/coupon",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/coupon.vue").then(m => m.default || m)
  },
  {
    name: "mypage-exchange",
    path: "/mypage/exchange",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/exchange.vue").then(m => m.default || m)
  },
  {
    name: "mypage-exchangeDetail",
    path: "/mypage/exchangeDetail",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/exchangeDetail.vue").then(m => m.default || m)
  },
  {
    name: "mypage-gma",
    path: "/mypage/gma",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/gma.vue").then(m => m.default || m)
  },
  {
    name: "mypage-gmaDetail",
    path: "/mypage/gmaDetail",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/gmaDetail.vue").then(m => m.default || m)
  },
  {
    name: "mypage",
    path: "/mypage",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/index.vue").then(m => m.default || m)
  },
  {
    name: "mypage-modify",
    path: "/mypage/modify",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/modify.vue").then(m => m.default || m)
  },
  {
    name: "mypage-mypage_addPay",
    path: "/mypage/mypage_addPay",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/mypage_addPay.vue").then(m => m.default || m)
  },
  {
    name: "mypage-mypage_addPayComplete",
    path: "/mypage/mypage_addPayComplete",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/mypage_addPayComplete.vue").then(m => m.default || m)
  },
  {
    name: "mypage-mypage_addPayNext",
    path: "/mypage/mypage_addPayNext",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/mypage_addPayNext.vue").then(m => m.default || m)
  },
  {
    name: "mypage-mypage_changePay",
    path: "/mypage/mypage_changePay",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/mypage_changePay.vue").then(m => m.default || m)
  },
  {
    name: "mypage-mypage_changePayComplete",
    path: "/mypage/mypage_changePayComplete",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/mypage_changePayComplete.vue").then(m => m.default || m)
  },
  {
    name: "mypage-mypage_changePayNext",
    path: "/mypage/mypage_changePayNext",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/mypage_changePayNext.vue").then(m => m.default || m)
  },
  {
    name: "mypage-mypage_ddobak",
    path: "/mypage/mypage_ddobak",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/mypage_ddobak.vue").then(m => m.default || m)
  },
  {
    name: "mypage-mypage_delivery",
    path: "/mypage/mypage_delivery",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/mypage_delivery.vue").then(m => m.default || m)
  },
  {
    name: "mypage-order",
    path: "/mypage/order",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/order.vue").then(m => m.default || m)
  },
  {
    name: "mypage-orderDetail",
    path: "/mypage/orderDetail",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/orderDetail.vue").then(m => m.default || m)
  },
  {
    name: "mypage-point",
    path: "/mypage/point",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/point.vue").then(m => m.default || m)
  },
  {
    name: "mypage-qna",
    path: "/mypage/qna",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/qna.vue").then(m => m.default || m)
  },
  {
    name: "mypage-qnaWrite",
    path: "/mypage/qnaWrite",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/qnaWrite.vue").then(m => m.default || m)
  },
  {
    name: "mypage-ttobakCoupon",
    path: "/mypage/ttobakCoupon",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/ttobakCoupon.vue").then(m => m.default || m)
  },
  {
    name: "mypage-ttobakDetail",
    path: "/mypage/ttobakDetail",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/ttobakDetail.vue").then(m => m.default || m)
  },
  {
    name: "mypage-ttobakPayment",
    path: "/mypage/ttobakPayment",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/ttobakPayment.vue").then(m => m.default || m)
  },
  {
    name: "mypage-withdrawal",
    path: "/mypage/withdrawal",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/withdrawal.vue").then(m => m.default || m)
  },
  {
    name: "mypage-withdrawalInfo",
    path: "/mypage/withdrawalInfo",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/mypage/withdrawalInfo.vue").then(m => m.default || m)
  },
  {
    name: "newttobakapp",
    path: "/newttobakapp",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/newttobakapp.vue").then(m => m.default || m)
  },
  {
    name: "noticeList",
    path: "/noticeList",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/noticeList.vue").then(m => m.default || m)
  },
  {
    name: "noticeView-no",
    path: "/noticeView/:no()",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/noticeView/[no].vue").then(m => m.default || m)
  },
  {
    name: "order-cart",
    path: "/order/cart",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/order/cart.vue").then(m => m.default || m)
  },
  {
    name: "order-payComplete",
    path: "/order/payComplete",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/order/payComplete.vue").then(m => m.default || m)
  },
  {
    name: "order-payError",
    path: "/order/payError",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/order/payError.vue").then(m => m.default || m)
  },
  {
    name: "order-payNext",
    path: "/order/payNext",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/order/payNext.vue").then(m => m.default || m)
  },
  {
    name: "order-setCombineShipping",
    path: "/order/setCombineShipping",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/order/setCombineShipping.vue").then(m => m.default || m)
  },
  {
    name: "order-setRoutineShipping",
    path: "/order/setRoutineShipping",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/order/setRoutineShipping.vue").then(m => m.default || m)
  },
  {
    name: "order-settle",
    path: "/order/settle",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/order/settle.vue").then(m => m.default || m)
  },
  {
    name: "privacy-230823",
    path: "/privacy/230823",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/privacy/230823.vue").then(m => m.default || m)
  },
  {
    name: "privacy-241231",
    path: "/privacy/241231",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/privacy/241231.vue").then(m => m.default || m)
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/privacy/index.vue").then(m => m.default || m)
  },
  {
    name: "probiotics",
    path: "/probiotics",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/probiotics.vue").then(m => m.default || m)
  },
  {
    name: "qr-link-no",
    path: "/qr/link/:no()",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/qr/link/[no].vue").then(m => m.default || m)
  },
  {
    name: "review-reviewindex",
    path: "/review/reviewindex",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/review/reviewindex.vue").then(m => m.default || m)
  },
  {
    name: "review-reviewWrite",
    path: "/review/reviewWrite",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/review/reviewWrite.vue").then(m => m.default || m)
  },
  {
    name: "service-type",
    path: "/service/:type()",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/service/[type].vue").then(m => m.default || m)
  },
  {
    name: "ssrApi",
    path: "/ssrApi",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/ssrApi.vue").then(m => m.default || m)
  },
  {
    name: "storeEvent",
    path: "/storeEvent",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/storeEvent.vue").then(m => m.default || m)
  },
  {
    name: "supporters1",
    path: "/supporters1",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/supporters1.vue").then(m => m.default || m)
  },
  {
    name: "test",
    path: "/test",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/test.vue").then(m => m.default || m)
  },
  {
    name: "test2",
    path: "/test2",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/test2.vue").then(m => m.default || m)
  },
  {
    name: "welcome",
    path: "/welcome",
    component: () => import("/var/lib/jenkins/workspace/STAGE_USER_NUXT/pages/welcome.vue").then(m => m.default || m)
  },
  {
    name: "naver-callback",
    path: "/callback",
    meta: CallbackNaverA6YI8z0hc3Meta || {},
    component: () => import("~/views/store/CallbackNaver.vue").then(m => m.default || m)
  },
  {
    name: "kakao-callback",
    path: "/callbackKakao",
    meta: CallbackKakaoYSbrXGtVbVMeta || {},
    component: () => import("~/views/store/CallbackKakao.vue").then(m => m.default || m)
  },
  {
    name: "apple-callback",
    path: "/callbackApple",
    component: () => import("~/views/store/CallbackApple.vue").then(m => m.default || m)
  },
  {
    name: "kakao-withdrawal-callback",
    path: "/callbackWithDrawalKakao",
    meta: CallbackWithDrawalKakaonknwxzx1ghMeta || {},
    component: () => import("~/views/store/CallbackWithDrawalKakao.vue").then(m => m.default || m)
  }
]